// ===============================
// AdminDashboard.tsx
// ===============================
import React from "react";
import { Outlet } from "react-router-dom";

const AdminDashboard: React.FC = () => {
  return (
    <div className="w-full">
      {/* <DashboardCore mode="ADMIN" /> */}

      <Outlet />
    </div>
  );
};

export default AdminDashboard;